import React from 'react';

function TestimonialsSection() {
    const testimonials = [
        {
            text: "Очень довольны работой! Потолки установили быстро и качественно. Цены действительно доступные. Рекомендую всем знакомым!",
            author: "Анна Петрова",
            rating: 5
        },
        {
            text: "Профессиональный подход и отличное качество. Дизайнер помог выбрать идеальный вариант для нашей гостиной. Спасибо!",
            author: "Сергей Иванов",
            rating: 5
        },
        {
            text: "Заказывали натяжные потолки во всю квартиру. Бригада работала слаженно, чисто и аккуратно. Результат превзошел ожидания!",
            author: "Елена Смирнова",
            rating: 5
        }
    ];

    return (
        <section className="testimonials-section">
            <div className="container">
                <div className="text-center mb-5">
                    <h2 className="section-title text-white">Отзывы клиентов</h2>
                    <p className="section-subtitle">Что говорят о нас наши клиенты</p>
                </div>
                <div className="row">
                    {testimonials.map((testimonial, index) => (
                        <div key={index} className="col-lg-4 col-md-6 animate-on-scroll">
                            <div className="testimonial-card">
                                <div className="testimonial-rating mb-3">
                                    {'★'.repeat(testimonial.rating)}
                                </div>
                                <p className="testimonial-text">"{testimonial.text}"</p>
                                <div className="testimonial-author">- {testimonial.author}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default TestimonialsSection;